import axios from "axios";
import { createContext, useContext, useState } from "react";

const PasswordAuthContext = createContext();

// const BASE_URL = "http://localhost:8000";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const PasswordAuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  /* ================= FORGOT PASSWORD ================= */
  const forgotPassword = async (email) => {
    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/api/auth/forgot-password`, {
        email,
      });
      console.log("res data from forget password", res);
      return res.data;
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async (payload) => {
    setLoading(true);

    try {
      const res = await axios.post(
        `${BASE_URL}/api/auth/reset-password`,
        payload,
      );

      return res.data;
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };
  const checkResetStatus = async (email) => {
    const res = await axios.get(`${BASE_URL}/api/auth/verify-status`, {
      params: { email },
    });

    return res.data;
  };
  return (
    <PasswordAuthContext.Provider
      value={{
        forgotPassword,
        resetPassword,
        checkResetStatus,
        loading,
      }}
    >
      {children}
    </PasswordAuthContext.Provider>
  );
};

export const usePassAuth = () => useContext(PasswordAuthContext);
